import React, { useEffect } from "react";
import { NavLink, useNavigate } from 'react-router-dom';
import Notifaction from './Notification'
import logo_img from "../../webroot/images/logo.svg";
import logo_img_fav from "../../webroot/images/logo-fav.svg";
import logo_img_tri from "../../webroot/images/logo-tri-header.svg";
import logo_img_emp from "../../webroot/images/logo-emp-page.svg";
import logo_img_ph from "../../webroot/images/logo-ph.svg";
import secureStorage from '../../config/encrypt'; 
import WithRights from "./WithRights";
import { TENANT, TENANTS, ADMIN_ROLES } from '../../config/constant';
    const Navigation = () => {
         const historyLead = useNavigate();
        const changeLanguage = (lang) => {      
                secureStorage.setItem('lang', lang);
        }       
        let language = secureStorage.getItem("lang") === TENANTS.OTO ? "ID" : "EN";
        let logged_data = localStorage.getItem("logged_data") ? JSON.parse(localStorage.getItem("logged_data")) : {}
        let display_name = (logged_data?.display_name) ? logged_data.display_name : '';
        let loginUserInfo = secureStorage.getItem('loginUserInfo') || {};
        const isSuperAdmin = loginUserInfo?.user_data?.admin_role_id === ADMIN_ROLES.super_admin;        
        useEffect(()=>{
            if(Object.keys(logged_data).length && (!display_name || !logged_data?.admin_role_rights )){
                historyLead('/logout');
            }
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [logged_data, display_name]);
      

        return (
            <div className="container-fluid" >
                {logged_data?.display_name &&
                <div className="header-main">
                    <div className="logo">
                         <img src={TENANT===TENANTS.PH ? logo_img_ph:TENANT===TENANTS.OTO ? logo_img :(TENANT===TENANTS.TRIV)? logo_img_tri :(TENANT===TENANTS.EMP)?logo_img_emp:logo_img_fav} className="" alt='SFA' /> 
                    </div>
                    <div className="right-panel-naviganion menupanel">
                        <div className="nav">
                            <ul>                                                     
                                <WithRights rightKey="user_management">
                                <li><NavLink to="/user-management">User Management</NavLink></li>
                                </WithRights>
                                {([TENANTS.PH, TENANTS.OTO, TENANTS.FAV, TENANTS.TRIV].includes(TENANT)) &&
                                    <>  
                                        <WithRights rightKey="map_dealer_executive">
                                        <li><NavLink to="/map-dealer">Map Dealer/Executive</NavLink></li>
                                        </WithRights>
                                        <WithRights rightKey="dealer_executive_mapping">
                                        <li><NavLink to="/dealer-user-listing">Dealer/Executive Mapping</NavLink></li>
                                        </WithRights>
                                        <WithRights rightKey="reports">
                                        <li className="dropdownmenu">
                                            <NavLink to="#">                                       
                                                <div className="username">
                                                    <span>Reports</span>                                            
                                                </div>
                                            </NavLink>
                                            <ul className="submenu">
                                                <WithRights rightKey="visit_report">
                                                <li><NavLink to="/view-report">Visit Reports</NavLink></li>
                                                </WithRights>
                                                <WithRights rightKey="no_visit_report">
                                                <li><NavLink to="/no-view-report">No Visit Reports</NavLink></li>
                                                </WithRights>
                                                {([TENANTS.PH].includes(TENANT)) && 
                                                <>
                                                <li>
                                                <NavLink to="/attendence-report">Attendance Report</NavLink>
                                                </li>
                                                <li>
                                                    <NavLink to="/role-history-report">Role History Report</NavLink>
                                                </li>
                                                </>
                                                }
                                            </ul> 
                                        </li>
                                        </WithRights>
                                    </>
                                }
                                <WithRights rightKey="access_more_dropdown">
                                    <li className="dropdownmenu">
                                        <NavLink to="#">                                       
                                            <div className="username">
                                                <span>More</span>                                            
                                            </div>
                                        </NavLink>
                                        <ul className="submenu">
                                            <WithRights rightKey="role_management">
                                            <li><NavLink to="/role-management">Role Management</NavLink></li>
                                            </WithRights> 
                                            <WithRights rightKey="journey_config">
                                            {(TENANT ===TENANTS.OTO) && <li><NavLink to="/progression-config"> Journey Config</NavLink> </li>}                                                                                
                                            </WithRights>
                                            <WithRights rightKey="journey_dashboard">
                                            {(TENANT ===TENANTS.OTO) && <li><NavLink to="/progression-dashboard">Journey Dashboard</NavLink> </li>}                                                                                
                                            </WithRights>
                                            <WithRights rightKey="sales_support_user_management">
                                            <li><NavLink to="/admin-user-management">Sales support user management</NavLink> </li>                                                                          
                                            </WithRights>
                                            <WithRights rightKey="sales_target">
                                            {([TENANTS.OTO, TENANTS.EMP].includes(TENANT)) && <li><NavLink to="/sales-target">Sales Target</NavLink> </li>  }                                                                              
                                            {TENANT === TENANTS.TRIV && <li><NavLink to="/tri-sales-target">Tri Sales Target</NavLink></li>}
                                            </WithRights>
                                            {TENANT !== TENANTS.PH && <li><NavLink to="/fid-tagging-upload">FID Tagging Upload</NavLink></li>}
                                            <WithRights rightKey="cbi_dashboard">{TENANT !== TENANTS.PH && <li><NavLink to="/cbi-dashboard">CBI Dashboard</NavLink></li>}</WithRights>
                                        </ul> 
                                    </li>
                                </WithRights>
                            </ul>                            
                        </div>
                        {TENANT !== TENANTS.PH && <WithRights rightKey="custom_notification">
                        <li className="notification-btn">
                            <NavLink to="/custom-notification">
                                <Notifaction />
                            </NavLink>
                        </li>
                        </WithRights>}

                        <div className="user-detail ">
                            <ul>

                                <li className="dropdownmenu">
                                    <NavLink to="#">
                                        <span className="userarc"> 
                                        T                                          
                                        </span>
                                        <div className="username">
                                            <span className="nowrap">{logged_data.role_display_name || 'Admin'}</span>
                                            <span className="user-degintion">{display_name}</span>
                                        </div>
                                    </NavLink>
                                    <ul className="submenu">
                                        <li><NavLink to="/logout">Logout</NavLink> </li> 
                                        {([TENANTS.PH, TENANTS.OTO, TENANTS.TRIV].includes(TENANT)) && <li><NavLink to="/office_address">Office Address</NavLink> </li>}
                                        <li><NavLink to="/reset_max_attempts">Reset Max Attempts</NavLink> </li>
                                        {isSuperAdmin && <li><NavLink to="/app-version-management">App Version Management</NavLink></li>}
                                    </ul>
                                </li>

                            </ul>
                        </div>

                        <div className="language">
                            <ul>
                                <li className="dropdownmenu">
                                    <NavLink to="#">
                                        {language}
                                    </NavLink>
                                    <ul className="submenu lang-menu">
                                        <li><NavLink to="#" onClick={() => changeLanguage('en')}>EN</NavLink></li>
                                        <li><NavLink to="#" onClick={() => changeLanguage('id')}>ID</NavLink></li> 
                                    </ul>
                                </li>

                            </ul>
                        </div>
                    </div>

                </div>
    }
            </div >
        );
} 
export default Navigation;